import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToolTipElement } from './ToolTipElement';
import styles from './stockStyles';
import DropDownIcon from '../icons/drop.png';
import StockHeader from './StockHeader';
import CustomDataTable from '../../components/CustomDataTable';
import {
  stockActiveStrikeVolumecolumns,
  stockOpenInterestcolumns,
  stockTopIndividualTradeColumns,
} from '../../constants/stockPageConstants';
import OIMODAL from '../../components/Modals/OI Modal';
import VolumeModal from '../../components/Modals/VolumeModal';
import { useHistory } from 'react-router-dom';
import { fetchQuoteInfoFunc } from '../../Shared';
import { setAppStateAction } from '../../actions/appStateAction';
import { fetchAllMain } from '../../Shared/stocks';

const TablesSection = ({ fetchAll, stockPageState, setStockPageState }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { appReducer } = useSelector((state) => state);
  const {
    accessLevel,
    isMobile,
    ThirdLoading,
    quoteInfo,
    secondLoading,
    weekendErrors,
    weekendErrorsBox2,
    weekendErrorsBox3,
    stockThirdTable,
    stockSecondTable,
    stockFirstTable,
    loading,
  } = appReducer;

  const [tableModal, setTableModal] = useState({
    OIModal: false,
    showModal: false,
    modalRowData: [],
  });

  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  const FetchDependendonCalender = (symbol, date) => {
    fetchAllMain(symbol, date, setAppState);
    fetchQuoteInfoFunc(symbol, date, appReducer, setAppState);
    localStorage.setItem('Date', date);
  };

  const activeStrikeRowClickHandler = (row, keyName) => {
    if (keyName === 'volume')
      setTableModal((prev) => ({
        ...prev,
        modalRowData: row,
        showModal: true,
      }));
    if (keyName === 'open_int') {
      setTableModal((prev) => ({ ...prev, modalRowData: row, OIModal: true }));
    }
    if (keyName === 'expiry') {
      localStorage.setItem('SYMBOL', row.usymbol);
      history.push(`/optionschain/${row.usymbol}`);
    }
  };
  const individualTradeRowClickHandler = (row, keyName) => {
    if (keyName === 'open_int') {
      setTableModal((prev) => ({ ...prev, modalRowData: row, OIModal: true }));
    }
    if (keyName === 'expiry') {
      localStorage.setItem('SYMBOL', row.usymbol);
      history.push(`/optionschain/${row.usymbol}`);
    }
    if (keyName === 'size') {
      let puttCallSplit = row.option.split('');
      let puttCallvalue = puttCallSplit[0];
      const objectToSend = {
        usymbol: stockPageState.symbol,
        expiry: row.expiry,
        ivol: row.ivol,
        ivolchg: row.ivol_chg,
        asize: row.asize,
        ask: row.ask,
        bid: row.bid,
        bsize: row.bsize,
        open_int: row.open_int,
        option: row.option,
        price: row.price,
        volume: row.size,
        strike: row.strike,
        put_call: puttCallvalue,
      };
      setTableModal((prev) => ({
        ...prev,
        modalRowData: objectToSend,
        showModal: true,
      }));
    }
  };
  const openInterestRowClickHandler = (row, keyName) => {
    if (keyName === 'volume')
      setTableModal((prev) => ({
        ...prev,
        modalRowData: row,
        showModal: true,
      }));
    if (keyName === 'open_int')
      setTableModal((prev) => ({ ...prev, modalRowData: row, OIModal: true }));
    if (keyName === 'expiry') {
      localStorage.setItem('SYMBOL', row.usymbol);
      history.push(`/optionschain/${row.usymbol}`);
    }
  };
  
  return (
    <Grid item xs={12} sm={12} md={9} lg={9} style={{ height: '100%' }}>
      <StockHeader
        fetchAll={fetchAll}
        stockPageState={stockPageState}
        setStockPageState={setStockPageState}
        FetchDependendonCalender={FetchDependendonCalender}
      />
      {tableModal.OIModal && (
        <OIMODAL
          type={tableModal.modalRowData.option ? 'stockPage' : undefined}
          accessLevel={accessLevel}
          isMobile={isMobile}
          showModal={tableModal.OIModal}
          ticker={stockPageState.symbol}
          expiration={tableModal.modalRowData.expiry}
          modalRowData={tableModal.modalRowData}
          closeOIModal={() =>
            setTableModal((prev) => ({ ...prev, OIModal: false }))
          }
          selectedDate={stockPageState.modalDate}
        />
      )}
      {tableModal.showModal && (
        <VolumeModal
          type={tableModal.modalRowData.option ? 'stockPage' : undefined}
          accessLevel={accessLevel}
          isMobile={isMobile}
          showModal={tableModal.showModal}
          modalRowData={tableModal.modalRowData}
          ticker={stockPageState.symbol}
          expiration={tableModal.modalRowData.expiry}
          modalDate={stockPageState.modalDate}
          selectedDate={stockPageState.modalDate}
          closeVolumeModal={() =>
            setTableModal((prev) => ({ ...prev, showModal: false }))
          }
        />
      )}
      {isMobile && stockPageState.table1Dropdown === false ? (
        ''
      ) : (
        <div
          style={
            isMobile
              ? styles.boardModalTableContainerMobile
              : { ...styles.boardModalTableContainer, width: '80%' }
          }
        >
          <CustomDataTable
            columns={stockActiveStrikeVolumecolumns}
            rows={stockFirstTable}
            loading={loading}
            clickHanlder={activeStrikeRowClickHandler}
            error={weekendErrors}
          />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: isMobile ? '7.2%' : '2.2%',
          marginLeft: '1%',
        }}
      >
        <div style={{ display: 'flex', width: !isMobile ? '54%' : '100%' }}>
          {isMobile && (
            <div
              style={styles.dropDown2}
              onClick={() =>
                setStockPageState({
                  ...stockPageState,
                  table2Dropdown: !stockPageState.table2Dropdown,
                })
              }
            >
              <img height="15px" width="15px" src={DropDownIcon} alt="" />
            </div>
          )}
          <div
            style={isMobile ? styles.headingStyleMobile : styles.headingStyle}
          >
            Top Individual Trades in {quoteInfo && quoteInfo.symbol}
          </div>
          <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
            <ToolTipElement
              clickHandler={() =>
                setStockPageState({
                  ...stockPageState,
                  showModal: !stockPageState.showModal,
                  type: 'databox2',
                })
              }
            />
          </div>
        </div>
        <div
          style={{
            color: 'grey',
            fontSize: isMobile ? '9px' : '12px',
            marginRight: '2.5%',
            marginTop: isMobile ? '0px' : '1.5%',
          }}
        >
          <em>Opra Data Delayed by 15 mins</em>{' '}
        </div>
      </div>
      {isMobile && stockPageState.table2Dropdown === false ? (
        ''
      ) : (
        <div
          style={
            isMobile
              ? styles.boardModalTableContainerMobile
              : { ...styles.boardModalTableContainer, width: '98%' }
          }
        >
          <CustomDataTable
            columns={stockTopIndividualTradeColumns}
            rows={stockSecondTable}
            loading={secondLoading}
            clickHanlder={individualTradeRowClickHandler}
            error={weekendErrorsBox2}
          />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          marginTop: isMobile ? '7.2%' : '2.2%',
          marginLeft: '1%',
        }}
      >
        {isMobile && (
          <div
            style={styles.dropDown3}
            onClick={() =>
              setStockPageState({
                ...stockPageState,
                table3Dropdown: !stockPageState.table3Dropdown,
              })
            }
          >
            <img height="15px" width="15px" src={DropDownIcon} alt="" />
          </div>
        )}

        <div style={isMobile ? styles.headingStyleMobile : styles.headingStyle}>
          Top Changes in {quoteInfo && quoteInfo.symbol} Open Interest
        </div>
        <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
          <ToolTipElement
            clickHandler={() =>
              setStockPageState({
                ...stockPageState,
                showModal: !stockPageState.showModal,
                type: 'databox3',
              })
            }
          />
        </div>
      </div>
      {isMobile && stockPageState.table3Dropdown === false ? (
        ''
      ) : (
        <div
          style={
            isMobile
              ? styles.boardModalTableContainerMobile
              : { ...styles.boardModalTableContainer, width: '80%' }
          }
        >
          <CustomDataTable
            columns={stockOpenInterestcolumns}
            rows={stockThirdTable}
            loading={ThirdLoading}
            clickHanlder={openInterestRowClickHandler}
            error={weekendErrorsBox3}
          />
        </div>
      )}
    </Grid>
  );
};

export default TablesSection;



// WEBPACK FOOTER //
// ./src/Pages/Stock/TablesSection.jsx